import { connect } from 'react-redux'
import requestChangeStartDate from '../../../sagas/requestChangeStartDate'
import requestChangeDueDate from '../../../sagas/requestChangeDueDate'
import requestAddCustomDate from '../../../sagas/requestAddCustomDate'
import { sagaActions as rootSagaActions } from 'store/sagas'
import addDateSelector from './addDateSelector'
import AddDate from './AddDate'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  addDateSelector,
  {
    requestChangeStartDate,
    requestChangeDueDate,
    requestAddCustomDate,
    requestAddPersonalDate: rootSagaActions.requestAddPersonalDate
  }
)(AddDate))
